@if ((wishlistOptions$ | async).length === 0) {
<formly-form [fields]="singleFieldConfig" [form]="formGroup()" />
} @else {
<div class="col-md-12">
  <formly-form [fields]="multipleFieldConfig$ | async" [form]="formGroup()" />
</div>
} @if (loading$ | async) {
<ish-loading />
}
